import { useState } from 'react';
import { ButtonLink } from './ButtonLink';
import { Container } from './Container';
import './SiteHeader.css';

const navigationItems = [
  { href: '#solution', label: 'Solution' },
  { href: '#how-it-works', label: 'How it works' },
  { href: '#impact', label: 'Impact' },
  { href: '#contact', label: 'Contact' },
];

export function SiteHeader() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const closeMenu = () => setIsMenuOpen(false);
  const handleKeyDown = (event) => {
    if (event.key === 'Escape') {
      closeMenu();
    }
  };

  return (
    <header className="site-header">
      <Container className="site-header__inner">
        <a className="site-header__brand" href="#hero" onClick={closeMenu}>
          <span className="site-header__mark" aria-hidden="true" />
          <span>Optivuo</span>
        </a>
        <button
          className="site-header__menu-toggle"
          type="button"
          aria-expanded={isMenuOpen}
          aria-controls="primary-navigation"
          onClick={() => setIsMenuOpen((currentValue) => !currentValue)}
        >
          <span className="site-header__menu-icon" aria-hidden="true" />
          <span className="site-header__menu-label">Menu</span>
        </button>
        <nav
          id="primary-navigation"
          className={`site-header__navigation ${isMenuOpen ? 'site-header__navigation--open' : ''}`}
          aria-label="Primary navigation"
          onKeyDown={handleKeyDown}
        >
          <div className="site-header__links">
            {navigationItems.map(({ href, label }) => (
              <a key={href} href={href} onClick={closeMenu}>
                {label}
              </a>
            ))}
          </div>
          <ButtonLink href="#contact" variant="primary" onClick={closeMenu}>
            Request a conversation
          </ButtonLink>
        </nav>
      </Container>
    </header>
  );
}
